var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.inputComponent.is,_vm._g(_vm._b({directives:[{name:"validate",rawName:"v-validate",value:(_vm.rules),expression:"rules"}],tag:"component",staticClass:"c-mixed-input-field"},'component',_vm.inputComponent.bind,false),_vm.inputComponent.on))
}
var staticRenderFns = []

export { render, staticRenderFns }